import React, { useState } from 'react';

import PayPerViewStore from '../../store/PayPerViewStore';


const ClipStoreItemPurchaseContent = (props) => {
  const {
    isItem,
    isErrorMessage,
    title,
    anchorName,
    price,
    closeModal,
    onBuyPayPerViewClip,
  } = props;
  const [disableBuyButton, setDisableBuyButton] = useState(false);
  const errorMessageClassName = isErrorMessage ? 'error-modal' : '';
  const buttonText = !PayPerViewStore.statusMessage.length ? 'Cancel' : 'Close';
  if (!isItem) {
    return null;
  }

  const onBuyClick = () => {
    setDisableBuyButton(true);
    onBuyPayPerViewClip();
  };

  let message = '';
  if (isErrorMessage) {
    message = PayPerViewStore.statusMessage;
  } else {
    message = `Are you sure you want to purchase "${title}" from ${anchorName} for $${price}?`;
  }

  return (
    <div className="pay-per-view-modal-caption">
      <div className="pay-per-view-modal-title">
        {message}
      </div>
      <div className={`pay-per-view-btn-container ${errorMessageClassName}`}>
        <button
          className="btn pay-per-view-modal-close"
          onClick={closeModal}
        >
          {buttonText}
        </button>
        {!isErrorMessage && (
          <button
            className="btn pay-per-view-modal-buy"
            disabled={disableBuyButton}
            onClick={onBuyClick}
          >
            Buy!
          </button>
        )}
      </div>
    </div>
  );
};

export default ClipStoreItemPurchaseContent;
